import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import AuthenticationService from "../Authentication/AuthenticationService";
import Swal from "sweetalert2";
import Eye from "../users/Eye";
import { toast } from "../NewUI/NewComponents/toastService";
import NewERPLogo from '../images/Finanzzi.png';
import NewERPbg from '../images/360 Degree Erp Logo.png';
// import NewERPbg from '../images/360 Degree Erp Logo.png';

export default function ForgotPassword() {

  const is360 = process.env.REACT_APP_FINANZZ_URL === "360";
  const navigate = useNavigate();
  const location = useLocation();

  const OTP_LENGTH = 4;
  const RESEND_SECONDS = 60;

  const [username, setUsername] = useState(location?.state?.username || "");
  const [clientname] = useState(location?.state?.clientname || "");

  const [otp, setOtp] = useState(Array(OTP_LENGTH).fill(""));
  const [activeIndex, setActiveIndex] = useState(0);
  const [secondsLeft, setSecondsLeft] = useState(RESEND_SECONDS);
  const [expiry,setExpiry] = useState(600)
  const [canResend, setCanResend] = useState(false);
  const [confirmstatus, setConfirmstatus] = useState("");

  const [newpassword, setNewPassword] = useState("");
  const [confirmpassword, setConfirmPassword] = useState("");
  const [showNew, setShowNew] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const inputsRef = useRef([]);

  useEffect(() => {
    if (secondsLeft <= 0) {
      setCanResend(true);
      return;
    }
    const timer = setInterval(() => setSecondsLeft((s) => s - 1), 1000);
    return () => clearInterval(timer);
  }, [secondsLeft]);

   useEffect(() => {
    if (expiry <= 0) {
      toast("Session expired");
     navigate("/");
    }
    const timer = setInterval(() => setExpiry((s) => s - 1), 1000);
    return () => clearInterval(timer);
  }, [expiry]);

  useEffect(() => {
    inputsRef.current[activeIndex]?.focus();
  }, [activeIndex]);

  useEffect(() => {
    if (!location?.state) {
      toast("Session expired");
      navigate("/");
    } else {
      generateOtp();
    }
  }, []);

  const generateOtp = () => {
    AuthenticationService.GenerateOTP(username);
  };

  const handleChange = (val, index) => {
    if (!/^[0-9]?$/.test(val)) return;
    const copy = [...otp];
    copy[index] = val;
    setOtp(copy);
    if (val && index < OTP_LENGTH - 1) setActiveIndex(index + 1);
  };

  const handleKeyDown = (e, index) => {
    if (e.key === "Backspace") {
      if (otp[index]) {
        const copy = [...otp];
        copy[index] = "";
        setOtp(copy);
      } else if (index > 0) {
        setActiveIndex(index - 1);
      }
    }
  };

  const handlePaste = (e) => {
    const data = e.clipboardData.getData("text").slice(0, OTP_LENGTH);
    if (!/^[0-9]+$/.test(data)) return;
    setOtp(data.split(""));
  };

  const verifyOtp = () => {
    const code = otp.join("");
    if (code.length !== OTP_LENGTH) return toast("Enter full OTP","info");

    AuthenticationService.VerifyOTP({ username, otp: parseInt(code) })
      .then((res) => setConfirmstatus("success"))
      .catch(() => toast("Invalid OTP","error"));
  };

  const handleSubmit = () => {
    if (!newpassword || newpassword.trim() ==="") return toast("Please enter new password","error");
    if (newpassword !== confirmpassword) return toast("Passwords don't match","error");

    AuthenticationService.ChangePassword({ id: username, password: newpassword })
      .then(() => {
        Swal.fire("Password reset successful", "", "success");
        navigate("/");
      });
  };

  const handleResend = () => {
    if (!canResend) return;
    generateOtp();
    setSecondsLeft(RESEND_SECONDS);
    setCanResend(false);
    setOtp(Array(OTP_LENGTH).fill(""));
  };

  return (
    <div className="tw-min-h-screen tw-flex tw-flex-col tw-items-center tw-justify-center tw-bg-transparent">
      <div className="tw-flex tw-justify-center">
       <img
                    src={is360 ? NewERPbg : NewERPLogo}
                    alt="Logo..."
                    className="tw-h-[60px] tw-mb-5"
                  />
                  </div>
      <div className="tw-bg-white tw-rounded-2xl tw-shadow-xl tw-p-10 tw-w-full tw-max-w-lg tw-text-center tw-border tw-border-purple-200 tw-mx-2">
        
        <h2 className="md:tw-text-lg tw-text-xl tw-font-semibold tw-mb-5">
          {is360 ? clientname || "360 ERP ENTERPRISE RESOURCE PLANNING" : clientname || "Jnana Software Technologies Pvt Ltd"}
        </h2>

        {confirmstatus !== "success" ? (
          <>
            <p className="tw-text-gray-500 tw-mb-6">
              Enter OTP to reset the password
            </p>

            <div className="tw-flex tw-justify-center tw-gap-4 tw-mb-4" onPaste={handlePaste}>
              {otp.map((d, i) => (
                <input
                  key={i}
                  ref={(el) => (inputsRef.current[i] = el)}
                  value={d}
                  onChange={(e) => handleChange(e.target.value, i)}
                  onKeyDown={(e) => handleKeyDown(e, i)}
                  className="tw-w-14 tw-h-14 tw-text-center tw-text-2xl tw-border-2 tw-border-purple-300 tw-rounded-lg focus:tw-ring-0 focus:tw-outline-gray-800 focus:tw-ring-purple-400"
                />
              ))}
            </div>

            <div className={expiry !== 0 ?"tw-my-4 tw-text-gray-600":"tw-py-4"}>
             {expiry !== 0 ? <> {String(Math.floor(expiry / 60)).padStart(2, "0")}:{String(expiry % 60).padStart(2, "0")}s</>:"OTP Expired"}
            </div>

            <button
              onClick={verifyOtp}
              className=" tw-bg-gray-800 tw-text-white tw-py-3 tw-rounded-lg tw-px-16"
            >
              CONFIRM
            </button>

            <div className="tw-mt-4 tw-text-sm">
              <button
                onClick={handleResend}
                disabled={!canResend}
                className={
                  canResend ? "tw-text-blue-600" : "tw-text-gray-400"
                }
              >
                Resend OTP ? {canResend ? "" : `${secondsLeft}s`}
              </button>
            </div>
          </>
        ) : (
          <>
           <p className="tw-text-gray-500 tw-mb-6">
              Setup your new password
            </p>
          <div className="tw-relative">
            <input
              type={showNew ? "text" : "password"}
              placeholder="New Password"
              className="tw-w-full tw-mb-3 tw-p-2 tw-border tw-rounded"
              onChange={(e) => setNewPassword(e.target.value)}
            />
            <span className="eye tw-top-[1px] tw-cursor-pointer" onClick={()=>setShowNew(prev=>!prev)}>
                         <Eye />
                       </span>
          </div>
            <input
              type={showConfirm ? "text" : "password"}
              placeholder="Confirm Password"
              className="tw-w-full tw-mb-3 tw-p-2 tw-border tw-rounded"
              onChange={(e) => setConfirmPassword(e.target.value)}
            />

            <button
              onClick={handleSubmit}
              className="tw-w-full tw-bg-gray-800 tw-text-white tw-py-3 tw-rounded-lg"
            >
              Submit
            </button>
          </>
        )}
      </div>
    </div>
  );
}